// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__dEQXR","upload":"Small_upload__1LEcT","imageWrap":"Small_imageWrap__2UlVj","removeBtn":"Small_removeBtn__1EzfK"};